
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M4.86 13.06a.5.5 0 010-.71l.2-.2a.488.488 0 01.36-.15H9V4.5a.5.5 0 01.5-.5h5a.5.5 0 01.5.5V12h3.58a.488.488 0 01.36.15l.2.2a.5.5 0 010 .71l-6.79 6.79a.477.477 0 01-.7 0l-6.79-6.79z"}})])
          )
        }
      }
    